<template lang="pug">
    section#banner
        .img
            img(:src="imagem", alt="" v-if="imagem")
            img(:src="require('@images/temp/top_single.jpg')", alt="", v-else)
        .wrapper
            p Compartilhe:
            ul
                li
                    a(href="#")
                        img(:src="require('@images/icones/fb-icon.png')", alt="Compartilhamento - Facebook")
                li
                    a(href="#")
                        img(:src="require('@images/icones/twitter-icon.png')", alt="Compartilhamento - Twitter")
                li
                    a(href="#")
                        img(:src="require('@images/icones/lk-icon.png')", alt="Compartilhamento - Linkedin")
</template>

<script>
export default {
    name: "section-banner",
    props: {
        imagem: String
    }
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>